import { Col, Form, FormInstance, Grid } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CalendarSelector } from "../../../../../../components";
import { PanelDateType } from "../../../../../../components/CalendarSelector/data";
import { useGetSessionSchedule } from "../../../../../../hooks/SessionSchedule/sessionSchedule.hooks";
import { InputRequired } from "../../../../../../validations/validations";
import { FormParams } from "../../data";
import "./styles.scss";

type HomeCalendarProps = {
  form: FormInstance;
  params: FormParams | undefined;
};

const HomeCalendar: React.FC<HomeCalendarProps> = ({ params, form }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [panelDate, setPanelDate] = useState<PanelDateType>();

  const { data: sessionSchedule, isPending } = useGetSessionSchedule(
    { ...panelDate, ...params },
    { enabled: !!panelDate }
  );

  useEffect(() => {
    if (!params) return;
    console.debug("params", params);
  }, [params]);

  return (
    <Col span={screens.lg ? 12 : 24}>
      <Form.Item name={"start_date"} hidden />
      <Form.Item name={"end_date"} hidden />
      <Form.Item
        name={"date"}
        label={screens.lg ? t("home.searchbar.date.title") : ""}
        style={{ marginBottom: 0 }}
        rules={[InputRequired(t, "home.searchbar.date.title")]}
      >
        <CalendarSelector
          setPanelDate={setPanelDate}
          schedule={sessionSchedule}
          form={form}
          isLoading={isPending}
        />
      </Form.Item>
    </Col>
  );
};

export default HomeCalendar;
